import Vue from 'vue'
import CONFIG from './../../config.js'
let actions = {
  login(context, params) {
    context.commit('addLog', { request:'Login' })
    return new Promise((resolve, reject) => {
      Vue.axios.post(CONFIG.getEndpoint('login'), params).then((response) => {
        //Store JWT in localStorage in case of page reloads
        localStorage.setItem("Authorization", response.data.sessionId)
        localStorage.setItem("User", JSON.stringify(response.data))
        //Set session id in store
        context.commit('user', response.data)

        context.commit('removeLog', { request:'Login' })
        resolve()
      }).catch((err)=>{
        // context.commit('hideLoader')
        context.commit('removeLog', { request:'Login' })
        reject(err.response.data)
      })
    })
  },
  logout(context, params) {
    context.commit('addLog', { request:'Logout' })
    return new Promise((resolve, reject) => {
      Vue.axios.get(CONFIG.getEndpoint('logout'), {
          headers: {
            Authorization:'Bearer '+ (params.sessionId || CONFIG.Authorization)
          }
        }).then((response) => {
        //Store JWT in localStorage in case of page reloads
        localStorage.removeItem("Authorization")
        localStorage.removeItem("User")
        //Set session id in store
        context.commit('user', undefined)
        context.commit('removeLog', { request:'Logout' })

        resolve()
      }).catch((err)=>{
        // context.commit('hideLoader')
        // context.commit('removeLog', { request:'Home' })
        if(err.response){ reject(err.response.data); return }
        context.commit('removeLog', { request:'Logout' })
        reject(err)
      })
    })
  }
}
export default actions



// WEBPACK FOOTER //
// ./src/store/login/actions.js